import { render } from "./workers.vue?vue&type=template&id=9a3988b8&scoped=true&ts=true"
import script from "./workers.vue?vue&type=script&lang=ts"
export * from "./workers.vue?vue&type=script&lang=ts"

import "./workers.vue?vue&type=style&index=0&id=9a3988b8&lang=stylus&scoped=true"
import "./workers.vue?vue&type=style&index=1&id=9a3988b8&lang=css"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a3988b8"]])

export default __exports__